import { render, staticRenderFns } from "./DashboardComercial.vue?vue&type=template&id=4022a54c&"
import script from "./DashboardComercial.vue?vue&type=script&lang=js&"
export * from "./DashboardComercial.vue?vue&type=script&lang=js&"
import style0 from "./DashboardComercial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports